var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50312 13.022L7.21612 16.707C7.60712 17.098 8.24012 17.098 8.63112 16.707C9.02212 16.316 8.99412 15.683 8.60312 15.292L6.31312 13L14.5001 13C15.0521 13 15.5001 12.552 15.5001 12C15.5001 11.448 15.0521 11 14.5001 11L6.31312 11L8.60712 8.708C8.99812 8.317 8.99812 7.684 8.60712 7.293C8.21612 6.902 7.58312 6.902 7.19212 7.293L3.49512 10.99C2.84412 11.641 2.82312 12.343 3.50312 13.022Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 9V7.169C12.5001 5.768 12.6661 5.107 13.1321 4.64C13.5981 4.173 14.2861 4 15.6691 4H16.3311C17.7141 4 18.4021 4.173 18.8721 4.644C19.3301 5.097 19.5001 5.781 19.5001 7.169V16.847C19.5001 18.218 19.3301 18.897 18.8681 19.354C18.3961 19.824 17.7131 20 16.3461 20H15.6691C14.2911 20 13.6021 19.826 13.1321 19.36C12.6661 18.894 12.5001 18.23 12.5001 16.823V15L10.5001 15V16.823C10.5001 18.146 10.5941 19.651 11.7211 20.777C12.8051 21.852 14.2591 22 15.6691 22H16.3461C17.7501 22 19.1991 21.851 20.2791 20.771C21.4061 19.655 21.5001 18.16 21.5001 16.847L21.5001 7.169C21.5001 5.844 21.4061 4.337 20.2831 3.226C19.1521 2.095 17.6501 2 16.3311 2H15.6691C14.3501 2 12.8481 2.095 11.7181 3.226C10.5941 4.349 10.5001 5.85 10.5001 7.169V9H12.5001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/signOut.6e941695c764064b2480792ee0d96ff4.svg";
export { ForwardRef as ReactComponent };